//@ts-check
// @ts-ignore
import Login from './login.riot';
import { loginRequest, loginSuccess, loginFailure } from './login.action';
import { getURLParameters } from '@/common/utils';
import { ajaxPost } from '../ajax';
import { connect } from '@/common/lib/riot-redux';
import { router } from '@riotjs/route';
import { openFailedDialog } from '@/common/components/kf-dialog';
import storage from '@/common/storage';

const mapStateToProps = (state) => {
  return {
    shopId: state.app.shopId,
    web: state.app.web,
    valid: state.app.valid,
    errorMsg: state.app.errMsgLogin
  };
};

const mapDispatchToProps = (dispatch) => ({
  async login(payload) {
    dispatch(loginRequest());
    const { shopId, phone, password } = payload;
    try {
      const res = await ajaxPost('/point', {
        method: 'login',
        shopId,
        phone,
        password
      });
      dispatch(loginSuccess(res));
      storage.setItem('phone', phone);
      storage.setItem('password', password);
      storage.setItem('shopId', shopId);
      const redirectUrl = getURLParameters(location.href).redirect;
      if (redirectUrl) {
        location.href = decodeURIComponent(redirectUrl);
      } else {
        router.push('user');
      }
    } catch (e) {
      dispatch(loginFailure(e));
    }
  },

  openFailedDialog(message) {
    dispatch(openFailedDialog(message));
  }
});

export default connect(Login, mapStateToProps, mapDispatchToProps);